<template>
  <g>
    <path
      d="M7.201 0c0.616 0 1.122 0.5 1.122 1.114v9.935l3.907-3.878c0.437-0.433 1.149-0.433 1.586 0 0.438 0.433 0.438 1.14 0 1.574l-5.774 5.732c-0.483 0.479-1.222 0.502-1.689 0l-5.774-5.732c-0.436-0.433-0.436-1.14 0-1.574s1.149-0.433 1.586 0l3.914 3.883v-9.941c0-0.614 0.504-1.114 1.122-1.114z"
    ></path>
    <path
      d="M14.4 16.886c0 0.614-0.504 1.114-1.121 1.114h-12.157c-0.618 0-1.122-0.5-1.122-1.114 0-0.612 0.504-1.114 1.122-1.114h12.157c0.616 0 1.121 0.502 1.121 1.114z"
    ></path>
  </g>
</template>
